import { CardRank } from '../types/card-rank'
import { CardSuite } from '../types/card-suite'
import { CardProps } from './card.props'

export class Card {
  public readonly rank: CardRank = this.cardProps.rank
  public readonly suite: CardSuite = this.cardProps.suite

  public constructor(private cardProps: CardProps) {}

  public get rankSymbol(): string {
    if (this.rank === 'Ace') {
      return 'A'
    }

    if (this.rank === 'Two') {
      return '2'
    }

    if (this.rank === 'Three') {
      return '3'
    }

    if (this.rank === 'Four') {
      return '4'
    }

    if (this.rank === 'Five') {
      return '5'
    }

    if (this.rank === 'Six') {
      return '6'
    }

    if (this.rank === 'Seven') {
      return '7'
    }

    if (this.rank === 'Eight') {
      return '8'
    }

    if (this.rank === 'Nine') {
      return '9'
    }

    if (this.rank === 'Ten') {
      return 'X'
    }

    if (this.rank === 'Jack') {
      return 'J'
    }

    if (this.rank === 'Queen') {
      return 'Q'
    }

    if (this.rank === 'King') {
      return 'K'
    }

    throw new Error(`Unable to return rank symbol for rank ${this.rank}`)
  }

  public get suiteSymbol(): string {
    if (this.suite == 'Spades') {
      return '♠️'
    }

    if (this.suite == 'Diamonds') {
      return '♦️'
    }

    if (this.suite == 'Hearts') {
      return '❤️'
    }

    if (this.suite == 'Clubs') {
      return '♣️'
    }

    throw new Error(`Unable to return suite symbol for rank ${this.suite}`)
  }

  public static fourSuiteComparer = (a: Card, b: Card): number => {
    if (a.suite === 'Diamonds' && b.suite === 'Diamonds') {
      return 0
    }

    if (
      a.suite === 'Diamonds' &&
      (b.suite === 'Spades' || b.suite === 'Hearts' || b.suite === 'Clubs')
    ) {
      return -1
    }

    if (a.suite === 'Spades' && b.suite === 'Spades') {
      return 0
    }

    if (a.suite === 'Spades' && (b.suite === 'Hearts' || b.suite === 'Clubs')) {
      return -1
    }

    if (a.suite === 'Hearts' && b.suite === 'Hearts') {
      return 0
    }

    if (a.suite === 'Hearts' && b.suite === 'Clubs') {
      return -1
    }

    if (a.suite === 'Clubs' && b.suite === 'Clubs') {
      return 0
    }

    return 1
  }

  public static threeSuiteComparerNoSpades = (a: Card, b: Card): number => {
    if (a.suite === 'Diamonds' && b.suite === 'Diamonds') {
      return 0
    }

    if (
      a.suite === 'Diamonds' &&
      (b.suite === 'Hearts' || b.suite === 'Clubs')
    ) {
      return -1
    }

    if (a.suite === 'Clubs' && b.suite === 'Clubs') {
      return 0
    }

    if (a.suite === 'Clubs' && b.suite === 'Hearts') {
      return -1
    }

    return 1
  }

  public static threeSuiteComparerNoHearts = (a: Card, b: Card): number => {
    if (a.suite === 'Spades' && b.suite === 'Spades') {
      return 0
    }

    if (
      a.suite === 'Spades' &&
      (b.suite === 'Diamonds' || b.suite === 'Clubs')
    ) {
      return -1
    }

    if (a.suite === 'Diamonds' && b.suite === 'Diamonds') {
      return 0
    }

    if (a.suite === 'Diamonds' && b.suite === 'Clubs') {
      return -1
    }

    return 1
  }

  public static rankComparer = (a: Card, b: Card): number => {
    if (a.rank === 'Two') {
      return -1
    }

    if (
      a.rank === 'Three' &&
      (b.rank === 'Four' ||
        b.rank === 'Five' ||
        b.rank === 'Six' ||
        b.rank === 'Seven' ||
        b.rank === 'Eight' ||
        b.rank === 'Nine' ||
        b.rank === 'Ten' ||
        b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Four' &&
      (b.rank === 'Five' ||
        b.rank === 'Six' ||
        b.rank === 'Seven' ||
        b.rank === 'Eight' ||
        b.rank === 'Nine' ||
        b.rank === 'Ten' ||
        b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Five' &&
      (b.rank === 'Six' ||
        b.rank === 'Seven' ||
        b.rank === 'Eight' ||
        b.rank === 'Nine' ||
        b.rank === 'Ten' ||
        b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Six' &&
      (b.rank === 'Seven' ||
        b.rank === 'Eight' ||
        b.rank === 'Nine' ||
        b.rank === 'Ten' ||
        b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Seven' &&
      (b.rank === 'Eight' ||
        b.rank === 'Nine' ||
        b.rank === 'Ten' ||
        b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Eight' &&
      (b.rank === 'Nine' ||
        b.rank === 'Ten' ||
        b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Nine' &&
      (b.rank === 'Ten' ||
        b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Ten' &&
      (b.rank === 'Jack' ||
        b.rank === 'Queen' ||
        b.rank === 'King' ||
        b.rank === 'Ace')
    ) {
      return -1
    }

    if (
      a.rank === 'Jack' &&
      (b.rank === 'Queen' || b.rank === 'King' || b.rank === 'Ace')
    ) {
      return -1
    }

    if (a.rank === 'Queen' && (b.rank === 'King' || b.rank === 'Ace')) {
      return -1
    }

    if (a.rank === 'King' && b.rank === 'Ace') {
      return -1
    }

    return 1
  }
}

export const cardNull: Card = new Card({ rank: 'Two', suite: 'Spades' })
